import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Search } from "lucide-react";

export default function Browse() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const q = params.get("q") || "";
  const category = params.get("category") || "";

  useEffect(() => { api.get("/categories").then(r => setCats(r.data || [])); }, []);

  useEffect(() => {
    setLoading(true);
    const qs = new URLSearchParams();
    if (q) qs.set("q", q);
    if (category) qs.set("category", category);
    api.get(`/products?${qs.toString()}`).then(r => { setProducts(r.data || []); }).finally(() => setLoading(false));
  }, [q, category]);

  const setCat = (slug) => {
    const next = new URLSearchParams(params);
    if (slug) next.set("category", slug); else next.delete("category");
    setParams(next);
  };

  return (
    <div data-testid="browse-page" className="pt-28 pb-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mb-8">
        {q ? <>Results for <span className="text-[#FF007F]">"{q}"</span></> : category ? <>Category: <span className="text-[#05D9E8]">{category}</span></> : <>All products</>}
      </h1>

      <form
        onSubmit={(e) => { e.preventDefault(); const next = new URLSearchParams(params); const v = e.target.q.value.trim(); if (v) next.set("q", v); else next.delete("q"); setParams(next); }}
        className="relative mb-10 max-w-xl"
      >
        <Search className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-zinc-500" />
        <input name="q" defaultValue={q} placeholder="Search…" className="input-dark pl-11" data-testid="browse-search-input" />
      </form>

      <div className="flex flex-wrap gap-2 mb-10">
        <button
          data-testid="cat-filter-all"
          onClick={() => setCat("")}
          className={`px-4 py-2 text-xs uppercase tracking-widest border ${!category ? "border-[#FF007F] text-[#FF007F]" : "border-white/10 text-zinc-400 hover:text-white"}`}
        >All</button>
        {cats.map(c => (
          <button
            key={c.slug}
            data-testid={`cat-filter-${c.slug}`}
            onClick={() => setCat(c.slug)}
            className={`px-4 py-2 text-xs uppercase tracking-widest border ${category === c.slug ? "border-[#FF007F] text-[#FF007F]" : "border-white/10 text-zinc-400 hover:text-white"}`}
          >{c.name}</button>
        ))}
      </div>

      {loading ? (
        <p data-testid="browse-loading" className="text-zinc-500">Loading…</p>
      ) : products.length === 0 ? (
        <p data-testid="browse-empty" className="text-zinc-500">Nothing here yet. Be the first to list.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
